// extracted by mini-css-extract-plugin
module.exports = {"pending__table":"index--pending__table--1T5te"};